export default "__VITE_PUBLIC_ASSET__c9f6b5ad__"